import { render, staticRenderFns } from "./Personalized.vue?vue&type=template&id=5abd8c4b&scoped=true"
import script from "./Personalized.vue?vue&type=script&lang=js"
export * from "./Personalized.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5abd8c4b",
  null
  
)

export default component.exports